exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-product-styles-___variant-selector__variantItem___2RLoy{display:flex;align-items:center;transition:none!important}.src-components-product-styles-___variant-selector__variantItem___2RLoy:hover{background-color:#b18433;color:#fff}.src-components-product-styles-___variant-selector__variantItem___2RLoy a{width:100%;text-align:left;transition:none!important}.src-components-product-styles-___variant-selector__variantItem___2RLoy a:hover{color:#fff!important}", ""]);

// exports
exports.locals = {
	"variantItem": "src-components-product-styles-___variant-selector__variantItem___2RLoy"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/product/styles/variant-selector.scss
 ** module id = 897
 ** module chunks = 0
 **/